module.exports = __webpack_public_path__ + "img/yilian.42469c6b.png";